import { Box, Text } from '@simplywallst/ui-core';

import { ResponsiveWidth } from '../ResponsiveWidth';

import { DiversificationDonutChart } from '../DiversificationDonutChart';

export const DiversificationAcrossGeographicalRegion = () => {
  return (
    <ResponsiveWidth>
      {({ width }) => (
        <Box position="relative">
          <Box
            position="absolute"
            top="50%"
            left="50%"
            transform="translateX(-50%) translateY(-50%)"
          >
            <Text typography="xSmall" color="whiteRGBA" opacity={0.5}>
              Coming Soon
            </Text>
          </Box>
          <DiversificationDonutChart width={width} />
        </Box>
      )}
    </ResponsiveWidth>
  );
};
